/*###########################################################################
// Components
//#########################################################################*/

/* Dynamic Components
//------------------*/

if (document.querySelector('.accordion')) {
  import('./_accordions')
}

if (document.querySelector('.copy-clipboard')) {
	import('./_copyClipboard')
}

if (document.querySelector('.cursor')) {
	import('./_cursor')
}

if (document.querySelector('.h-screen') || document.querySelector('.min-h-screen')) {
	import('./_hScreenCalc')
}

if (document.querySelector('.modal')) {
	import('./_modals')
}

if (document.querySelector('.responsive-video')) {
	import('./_responsiveVideo')
}

if (document.querySelector('.search-field')) {
	import('./_searchResults')
}

if (document.querySelector('.sliderText')) {
	import('./_sliderText')
}

if (document.querySelector('.sprigFilter')) {
	import('./_sprigFilter')
}

if (document.querySelector('.themeSelect')) {
	import('./_themeSelect')
}

/* Standard Components
//------------------*/

import './_browserDetect'
import './_forms'
import './_header'
import './_reveal'
import './_scrollTo'
